import React from 'react';
import { Box, Typography } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import testImage from './testImages/review.png'

import review1 from '../../assets/img/osperb/googleReview/review1.jpeg'
import review2 from '../../assets/img/osperb/googleReview/review2.jpeg'
import review3 from '../../assets/img/osperb/googleReview/review3.jpeg'

// Video item interface
interface VideoItem {
    id: number;
    title: string;
    year: string;
    videoSrc: string;
    duration: string;
    thumbnail?: string;
}

// Google review screenshot interface
interface ReviewScreenshot {
    id: number;
    imageSrc: string;
    alt: string;
}

interface Section9Props {
    type?: string;
}

function Section9({ type }: Section9Props) {
    const isWeb = type === 'web';

    // Sample Google review screenshots - replace with actual screenshots
    const reviewScreenshots: ReviewScreenshot[] = [
        {
            id: 1,
            imageSrc: review1,
            alt: 'Osperb Google Review - Best Custom Software Development Company Kerala',
        },
        {
            id: 2,
            imageSrc: review2,
            alt: 'Osperb Google Review - Top ERP NEXT Development Company Malappuram',
        },
        {
            id: 3,
            imageSrc: review3,
            alt: 'Osperb Google Review - Leading Mobile App Development Company in Kerala',
        },

    ];


    // Review screenshots slider settings removed

    return (
        <Box
            sx={{
                backgroundColor: 'black',
                padding: '30px 0 0px',
                position: 'relative',
            }}
        >
            <a href='https://g.page/r/Ce0PgulbEBWwEBA?we' target='blank' title="Read Google Reviews for Osperb - Best Software Company Malappuram">
                {/* ============ PART 2: GOOGLE REVIEW SECTION ============ */}
                <Box
                    sx={{
                        backgroundColor: '#1a1a1a',
                        paddingY: isWeb ? 10 : 6,
                        paddingX: isWeb ? 8 : 3,
                        borderRadius: '40px 40px 0 0',
                        cornerShape: 'squircle',
                        marginTop: isWeb ? 0 : -3,
                        display: isWeb ? 'flex' : 'block',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: isWeb ? '10px' : 0,
                        minHeight: isWeb ? "600px" : "auto"
                    }}
                >
                    {/* Rating and Title */}
                    <Box sx={{
                        textAlign: isWeb ? 'left' : 'center',
                        mb: isWeb ? 0 : 4,
                        width: isWeb ? '35%' : '100%',
                        flexShrink: 0
                    }}>
                        {/* 5.0 Stars */}
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Typography
                                className="font-satoshi-bold"
                                sx={{
                                    color: '#fff',
                                    fontSize: '24px',
                                    fontWeight: 700,
                                }}
                            >
                                5.0
                            </Typography>
                            {[...Array(5)].map((_, index) => (
                                <StarIcon
                                    key={index}
                                    sx={{
                                        color: '#FFD700',
                                        fontSize: '24px',

                                    }}
                                />
                            ))}
                        </Box>

                        {/* Google-Rated Heading with Colorful Text */}
                        <Typography
                            className="font-satoshi-bold"
                            sx={{
                                fontSize: isWeb ? '48px' : '32px',
                                fontWeight: 700,
                                lineHeight: '120%',
                                mb: 1,
                                textAlign: 'center',
                            }}
                        >
                            <Box component="span" sx={{ color: '#4285F4' }}>G</Box>
                            <Box component="span" sx={{ color: '#EA4335' }}>o</Box>
                            <Box component="span" sx={{ color: '#FBBC05' }}>o</Box>
                            <Box component="span" sx={{ color: '#4285F4' }}>g</Box>
                            <Box component="span" sx={{ color: '#34A853' }}>l</Box>
                            <Box component="span" sx={{ color: '#EA4335' }}>e</Box>
                            <Box component="span" sx={{ color: '#fff' }}>-Rated</Box>
                        </Typography>

                        {/* Technology Partner Subheading */}
                        <Typography
                            className="font-satoshi-bold"
                            sx={{
                                color: '#fff',
                                fontSize: '20px',
                                fontWeight: 700,
                                lineHeight: '110%',
                                mb: 4,
                                textAlign: 'center',
                            }}
                        >
                            Technology Partner
                        </Typography>

                        {/* Description */}
                        <Typography
                            className="font-satoshi-regular"
                            sx={{
                                color: '#FFFFFF99',
                                fontSize: '13px',
                                lineHeight: '150%',
                                maxWidth: '360px',
                                mx: 'auto',
                                px: 2,
                                textAlign: 'center',
                            }}
                        >
                            Trusted by real businesses for long-term partnership,
                            reliability, fast support, smooth handling of complex
                            systems and enterprise-grade solutions
                        </Typography>
                    </Box>

                    <Box sx={{
                        width: isWeb ? '65%' : '100%',
                        overflow: 'hidden'
                    }}>

                        {/* Google Review Screenshots Slider */}
                        <Box sx={{
                            mx: isWeb ? 0 : -3,
                            overflowX: 'auto',
                            whiteSpace: 'nowrap',
                            display: 'flex',
                            gap: 1.5,
                            px: isWeb ? 0 : 2,
                            pb: 1,
                            scrollbarWidth: 'none',
                            '&::-webkit-scrollbar': {
                                display: 'none'
                            },
                        }}>
                            {reviewScreenshots.map((review) => (
                                <Box key={review.id} sx={{
                                    px: 0,
                                    flexShrink: 0,
                                }}>
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            width: isWeb ? '300px' : 'auto',
                                            maxHeight: "350px",
                                            borderRadius: '16px',
                                            cornerShape: "squircle",
                                            overflow: 'hidden',
                                            backgroundColor: "#1F1F1F",
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src={review.imageSrc}
                                            alt={review.alt}
                                            sx={{
                                                width: '100%',
                                                height: isWeb ? "350px" : '200px',
                                                display: 'block',
                                                aspectRatio: '10/12',
                                                objectFit: 'contain',
                                            }}
                                        />
                                    </Box>
                                </Box>
                            ))}
                        </Box>

                        {/* Bottom Caption */}
                        <Typography
                            className="font-satoshi-regular"
                            sx={{
                                color: '#FFFFFF99',
                                fontSize: '14px',
                                fontWeight: 400,
                                textAlign: 'center',
                                mt: 2,
                            }}
                        >
                            What our clients say about working with Osperb
                        </Typography>
                    </Box>
                </Box>
            </a>

        </Box>
    );
}

export default Section9;
